import type { ComponentPropsWithoutRef, ReactNode } from 'react'

export function Card({ className = '', ...props }: ComponentPropsWithoutRef<'div'>) {
  return <div className={`rounded-2xl border border-line bg-bg-elev ${className}`} {...props} />
}

type Tom = 'neutro' | 'sim' | 'nao' | 'abst' | 'obstr' | 'muted'

const TONS: Record<Tom, string> = {
  neutro: 'border-line text-fg',
  sim: 'border-vote-sim/40 text-vote-sim',
  nao: 'border-vote-nao/40 text-vote-nao',
  abst: 'border-vote-abst/40 text-vote-abst',
  obstr: 'border-vote-obstr/40 text-vote-obstr',
  muted: 'border-line text-fg-muted',
}

export function Pill({ tom = 'neutro', className = '', children, ...props }: ComponentPropsWithoutRef<'span'> & { tom?: Tom }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 font-mono text-[11px] uppercase tracking-wide ${TONS[tom]} ${className}`}
      {...props}
    >
      {children}
    </span>
  )
}

export function Swatch({ cor, className = '' }: { cor: string; className?: string }) {
  return <span aria-hidden className={`inline-block size-2.5 shrink-0 rounded-full ${className}`} style={{ backgroundColor: cor }} />
}

export function SectionTitle({ children, acao }: { children: ReactNode; acao?: ReactNode }) {
  return (
    <div className="mb-4 flex items-end justify-between gap-4">
      <h2 className="font-display text-2xl tracking-tight">{children}</h2>
      {acao}
    </div>
  )
}

export function Skeleton({ className = '' }: { className?: string }) {
  return <div aria-hidden className={`animate-pulse rounded-xl bg-fg/5 ${className}`} />
}

export function Stat({ rotulo, valor, tom = 'neutro' }: { rotulo: string; valor: ReactNode; tom?: Tom }) {
  const cor = tom === 'sim' ? 'text-vote-sim' : tom === 'nao' ? 'text-vote-nao' : tom === 'abst' ? 'text-vote-abst' : tom === 'obstr' ? 'text-vote-obstr' : 'text-fg'
  return (
    <div className="min-w-0">
      <div className="font-mono text-[11px] uppercase tracking-wide text-fg-muted">{rotulo}</div>
      <div className={`font-display text-3xl leading-none tabular-nums ${cor}`}>{valor}</div>
    </div>
  )
}

export function Aviso({ children, tom = 'abst' }: { children: ReactNode; tom?: 'abst' | 'nao' | 'neutro' }) {
  const borda = tom === 'nao' ? 'border-vote-nao/40' : tom === 'abst' ? 'border-vote-abst/40' : 'border-line'
  return <div className={`rounded-xl border ${borda} bg-bg px-4 py-3 text-sm text-fg-muted`}>{children}</div>
}
